import { render } from "./ContentAnnotationList.vue?vue&type=template&id=5b8e133d&scoped=true&ts=true"
import script from "./ContentAnnotationList.vue?vue&type=script&lang=ts"
export * from "./ContentAnnotationList.vue?vue&type=script&lang=ts"

import "./ContentAnnotationList.vue?vue&type=style&index=0&id=5b8e133d&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8e133d"]])

export default __exports__